module.exports = __webpack_public_path__ + "static/img/dotted-pattern.806bbcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dotted-pattern.png
// module id = BPYt
// module chunks = 78